/**
 * A link's secret, from the address's fragment - which no server ever sees - taken once and
 * removed from the address right away, so neither history nor a bookmark keeps it
 * (ADR-026, ADR-031).
 */
export function takeLinkToken(here: string): string | null {
  const token = window.location.hash.slice(1);
  if (token.length === 0) return null;
  window.history.replaceState(null, '', here);
  return token;
}
